export const defaultMetaImage =
  'https://anchor-public-media.s3.us-east-2.amazonaws.com/prod/anchor-yacht-rentals.jpg';

// home
export const homePageTitle = 'Anchor: Boat Rentals and Yacht Rentals Near Me';
export const homePageDescription =
  'Browse, shop, and compare the best luxury ' +
  'yacht rentals, yacht charters and boat rentals near you. Choose from a list of ' +
  'professional Captains for half-day, full-day, and multi-day yacht ' +
  'charter options. Speak with a live agent now and customize your yacht ' +
  'rental today or book online.';

// contact
export const contactPageTitle = 'Anchor Yacht Rentals: Contact Us';
export const contactPageDescription =
  "Get in touch with a member of Anchor's Professional Yacht Charter Team today!";

// list your boat
export const listYourBoatPageTitle = 'Anchor: Charter your boat or yacht today';
export const listYourBoatPageDescription =
  'Anchor is a turn-key charter solution ' +
  'for your boat or yacht. Gain access to the largest network of USCG ' +
  'Licensed Captains in the world and learn how you can earn money ' +
  'while your boat sits idle. ';

// become a captain - temporary title and description until we hear back from marketing
export const becomeACaptainPageTitle =
  'Boat Captain Jobs | Join The Anchor Community | Sign Up Now';
export const becomeACaptainPageDescription =
  'Earn Money On Your Schedule. Get Paid Quickly With Our Boat Captain Jobs.  Join Our Fast-Growing Community Now!';

// broker
export const brokerPageTitle = 'Become an Anchor Charter Broker today';
export const brokerPageDescription =
  'Refer yachts. Earn Commission. The Anchor Broker ' +
  'Portal allows yacht brokers, affiliates, and partners ' +
  'to sign up and start earning top commissions. Access the ' +
  'largest fleet of day charter boats and upload your own fleet and earn more.';

// passenger FAQ
export const passengerFAQPageTitle = 'Anchor Yacht Rentals: FAQs by Renters';
export const passengerFAQPageDescription =
  'Get quick answers to your questions about renting ' +
  'a boat, yacht rentals, or yacht charters here.';

// captain FAQ
export const captainFAQPageTitle = 'Anchor Yacht Rentals: FAQs by Captains';
export const captainFAQPageDescription =
  'Get quick answers to your questions about renting a ' +
  'boat, yacht rentals, or yacht charters here.';

// boatOwner FAQ
export const boatOwnerFAQPageTitle =
  'Anchor Yacht Rentals: FAQs by Boat Owners';
export const boatOwnerFAQPageDescription =
  'Get quick answers to your questions about renting your yacht, ' +
  'chartering your yacht, or renting your boat on Anchor.';

// terms
export const termsPageTitle = 'Anchor Yacht Rentals: Terms of Use & Legal';
export const termsPageDescription = 'Review our Terms of Use here.';

// privacy policy
export const privacyPageTitle = 'Anchor Yacht Rentals: Privacy Policy & Legal';
export const privacyPageDescription = 'Review our Privacy Policy here.';

// buyflow vessel details
export const vesselDetailsDescription =
  'Renting your dream boat or yacht is easy with Anchor; the #1 boat & yacht rental community.';

// buyflow locations
export function getLocationTitle(name: string, pageTitle?: string): string {
  if (pageTitle) {
    return pageTitle;
  }
  return `${name.replace('yacht rentals', '')} Yacht Rentals | ${name.replace(
    'yacht rentals',
    '',
  )} Boat Rentals & Yacht Charters | Anchor`;
}
export function getLocationDescription(
  name: string,
  state: string,
  metaDescription: string,
): string {
  if (metaDescription) {
    return metaDescription;
  }
  return `Anchor offers the best boat rental, yacht rental, and luxury yacht charter selection in ${name}. Shop, compare, and book the best boat and yacht rentals in ${state}. Let our team of Charter Professionals help plan your next boat day.`;
}
